import { Box, type BoxProps } from "@mui/material";
import type { FC } from "react";

export const GradientBackground: FC<BoxProps> = ({ sx = [], ...props }) => (
  <Box
    sx={[
      (theme) =>
        theme.palette.mode === "light"
          ? {
              background: `linear-gradient(to bottom, #f4e8f5 0%, #eeeaf7 20%, #d8e6f9 60%, #d0eff9 100%)`,
            }
          : {
              background: `linear-gradient(to bottom, #0c0f1f 0%, #0b1230 40%, #062039 70%, #032b36 100%)`,
            },
      ...(sx instanceof Array ? sx : [sx]),
    ]}
    {...props}
  />
);
